import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import {Blocco} from "../_Models/blocco";
import {ApiRestService} from "../api-rest.service";
import {ToastrService} from "ngx-toastr";
import {IDropdownSettings} from "../../../LibrerieCustom/MultiselectDropdown";

@Component({
  selector: 'app-blocchi-list',
  templateUrl: './blocchi-list.component.html'
})
export class BlocchiListComponent implements OnInit, OnChanges {
  DropdownSettings: IDropdownSettings = {
    singleSelection: true,
    enableCheckAll: false,
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    textField: "nome",
  };
  @Input() Blocchi: Blocco[];
  @Output() BlocchiChange = new EventEmitter<Blocco[]>();
  @Output() Refresh = new EventEmitter();
  cerca: string = "";
  constructor(
    private apiRest: ApiRestService,
    private toastrservice: ToastrService,
  ) {}
  ngOnInit(): void {}
  ngOnChanges(changes: SimpleChanges) {
    const blocchi = changes['Blocchi']?.currentValue;
    console.log("blocchi",this.Blocchi)
    this.apiRest.BlocchiList({}).subscribe(data => {
      data?.forEach(blocco => {
        if(blocco){
          this.apiRest.ContenutoList({blocco_id: blocco.id}).subscribe(data => {
            var sel = this.Blocchi?.findIndex(x => x.id == blocco.id);
            if(sel> -1)
              this.Blocchi[sel] = ({id: blocco.id, nome: blocco.nome, contenutiList: data,contenuto: this.Blocchi[sel].contenuto, testo: this.Blocchi[sel].testo, modifica:true, checked:this.Blocchi[sel].checked,});
            else
              this.Blocchi.push({id: blocco.id, nome: blocco.nome, contenutiList: data, testo: "", modifica:true, });
          });
        }

      });
    });
  }
  ContenutoChange(item: Blocco, selected){
    if(!selected || selected.lenght == 0 || !selected[0]) return;
    console.log(selected)
    item.checked = true;
    if(!(item.testo?.length>0))
    this.apiRest.GetContenuto({id: selected[0].id}).subscribe(data=>  item.testo = data)
  }
  Check(item: Blocco, val: boolean) {
    item.checked = val;
  }
}


@Pipe({
  name: 'CercaFilter',
  pure: false
})
export class CercaFilter implements PipeTransform {
  transform(items: Blocco[], filter: string): any {
    return !items? items: items.filter(item => item?.nome.toLowerCase().includes(filter.toLowerCase()));
  }
}
